// Before adding a new feature consider the fact that the below map is used as a whitelist for SerpResultDataParser.js
export const FEATURE_TYPES = {
    FEATURED_SNIPPET: 'FEATURED_SNIPPET',
    MAP_PACK: 'MAP_PACK',
    LOCAL_PACK: 'LOCAL_PACK',
    ORGANIC: 'ORGANIC',
    PEOPLE_ALSO_ASK: 'PEOPLE_ALSO_ASK',
    AI_OVERVIEW: 'AI_OVERVIEW',
    SHOP_RESULTS: 'SHOP_RESULTS',
    KNO_GRAPH: 'KNO_GRAPH',
};
